export default function Queue() {
  let items = [];
  let size = 10;

  function enqueue(item) {
    if (items.length == size) {
      dequeue();
    }
    const exist = items.findIndex(
      (it) => it.start.code == item.start.code && it.end.code == item.end.code
    );
    if (exist >= 0) {
      Object.assign(items[exist], item);
      return;
    }
    items.push(item);
  }
  function dequeue() {
    if (isEmpty()) return [];
    return items.shift();
  }

  function isEmpty() {
    return items.length == 0;
  }
  function getQueue() {
    return items || [];
  }
  function setQueue(data) {
    items = data;
  }
  return { enqueue, setQueue, dequeue, isEmpty, getQueue };
}
